export const tripType = {
  S: 'Single Trip',
  A: 'Annual Multi-trip'
}

export const travelType = {
  I: 'Individual',
  F: 'Family'
}

export const relationship = {
  S: 'Spouse',
  C: 'Child'
}

export const paymentMode = {
  CC: 'Credit Card/Debit Card',
  CH: 'Cash/Cheque'
}
